import { render, staticRenderFns } from "./ConfirmBindYandex.vue?vue&type=template&id=4d55386d&"
import script from "./ConfirmBindYandex.vue?vue&type=script&lang=js&"
export * from "./ConfirmBindYandex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports